import React, { useState } from "react"
import { IoFilterCircleOutline, IoFilterCircleSharp } from "react-icons/io5"
import useT from "utils/useT"
import Modal from "./modal"
import useMediaQuery from "utils/useMediaQuery"
import FiltersModal from "views/apps/FiltersModal"

interface Props {
  page: "apps" | "games" | "all"
  setPage: (page: "apps" | "games" | "all") => void
  price: string
}

function Tabs({ page, setPage, price }: Props) {
  const t = useT()
  const isDesktop = useMediaQuery("(min-width: 900px)")
  const [openFilters, setOpenFilters] = useState(false)
  return (
    <>
      <div className="btn-group w-100 p-3 mt-n4">
        <button
          onClick={() => setPage("apps")}
          className={`btn rounded-start ${
            page === "apps"
              ? "bg-blue-dark"
              : "color-blue-light border-1 border-blue-light"
          }`}
        >
          <i className="me-2 fab fa-app-store-ios" />
          {t.apps.apps}
        </button>
        <button
          onClick={() => setPage("games")}
          className={`btn ${
            page === "games"
              ? "bg-blue-dark"
              : "color-blue-light border-1 border-blue-light"
          }`}
        >
          <i className="fa fa-gamepad pe-2"></i>
          {t.apps.games}
        </button>
        <button
          onClick={() => setPage("all")}
          className={`btn rounded-end ${
            page === "all"
              ? "bg-blue-dark"
              : "color-blue-light border-1 border-blue-light"
          }`}
        >
          <i className="fa fa-star pe-2"></i>
          {t.apps.all}
        </button>
        <button className="ms-1 ps-1 pe-1" onClick={() => setOpenFilters(true)}>
          {price ? (
            <IoFilterCircleSharp size={38} className="color-blue-dark" />
          ) : (
            <IoFilterCircleOutline size={38} className="color-blue-dark" />
          )}
        </button>
      </div>
      <Modal
        isCenter={isDesktop}
        modalOpen={openFilters}
        close={() => setOpenFilters(false)}
      >
        <FiltersModal onAccept={() => setOpenFilters(false)} />
      </Modal>
    </>
  )
}

export default Tabs
